import styled from '@emotion/styled'

export const Card = styled.div`
    padding: 24px;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
`;
